module.exports = __webpack_public_path__ + "static/media/pk.5605738e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/pk.png
// module id = 1956
// module chunks = 0